import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

/** Number stepper (−/value/+) with clamping. Parent owns state via [value]/(valueChange). */
@Component({
  selector: 'bb-stepper',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="inline-flex items-center overflow-hidden rounded-md border border-border w-full">
      <button
        type="button"
        [attr.aria-label]="'Decrease ' + label()"
        class="grid size-11 place-items-center text-lg text-muted-foreground transition-colors hover:bg-muted hover:text-foreground disabled:opacity-40"
        [disabled]="value() <= min()"
        (click)="step(-1)">−</button>
      <input
        type="text"
        inputmode="numeric"
        [attr.aria-label]="label()"
        [value]="value()"
        (change)="onInput($event)"
        class="h-11 flex-1 border-x border-border bg-transparent text-center font-heading text-lg font-bold text-foreground outline-none" />
      <button
        type="button"
        [attr.aria-label]="'Increase ' + label()"
        class="grid size-11 place-items-center text-lg text-muted-foreground transition-colors hover:bg-muted hover:text-foreground disabled:opacity-40"
        [disabled]="value() >= max()"
        (click)="step(1)">+</button>
    </div>
  `,
})
export class BbStepper {
  readonly value = input<number>(1);
  readonly min = input<number>(1);
  readonly max = input<number>(999);
  readonly label = input<string>('value');
  readonly valueChange = output<number>();

  private clamp(n: number): number {
    if (Number.isNaN(n)) {
      return this.min();
    }
    return Math.max(this.min(), Math.min(this.max(), n));
  }

  step(delta: number): void {
    this.valueChange.emit(this.clamp(this.value() + delta));
  }

  onInput(event: Event): void {
    const raw = (event.target as HTMLInputElement).value;
    this.valueChange.emit(this.clamp(parseInt(raw, 10)));
  }
}
